export default {
	onBurgerClick() {
		// Permamently set this as false once the user clicks on the burguer icon
		this.isWrapperZeroHeight = false;

		// Before opening the menu, reset the submenus.
		if (!this.active && this.$parent.$refs.submenu) {
			for (const item of this.$parent.$refs.submenu) {
				item.checked = false;
			}
		}

		this.$store.commit("toggleBurger");
		if (this.active) {
			this.$store.dispatch("trackEvent", {
				eventCategory: "Header",
				eventAction: "Click on Mobile MENU button",
				eventLabel: "OpenMobileMenu",
			});
		}
	},
};
